// Globals
import { useTranslation } from 'react-i18next';
import { StopCrossIcon } from '@/icons';

// Components
import {
  StyledModal,
  StyledTitle,
  StyledDescription,
  StyledButtons,
  StyledButton,
  StyledConfirmButton,
} from './Styles';

interface IStopConfirmationModal {
  isOpened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const StopConfirmationModal = ({ onConfirm, isOpened, onClose }: IStopConfirmationModal) => {
  const { t } = useTranslation(['property']);

  return (
    <StyledModal open={isOpened} onCancel={onClose} footer={null}>
      <StyledTitle>{t('ad_order_stop_confirmation_title')}</StyledTitle>
      <StyledDescription>{t('ad_order_stop_confirmation_description')}</StyledDescription>
      <StyledButtons>
        <StyledButton onClick={onClose} shape="round">
          {t('ad_order_cancel')}
        </StyledButton>
        <StyledConfirmButton
          onClick={onConfirm}
          type={'primary'}
          shape="round"
          iconPosition={'end'}
          icon={<StopCrossIcon />}
        >
          {t('ad_order_stop_confirm')}
        </StyledConfirmButton>
      </StyledButtons>
    </StyledModal>
  );
};

export default StopConfirmationModal;
